import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import i18n from '@/plugins/i18n';
import appTheme from '@/themes';

//import "typeface-roboto/index.css";
import fontes from '../../styles/fonts.scss';
import "@mdi/font/css/materialdesignicons.min.css";

import { VAutocomplete, VCheckbox, VTextField } from 'vuetify/lib';
import { VExpansionPanels } from 'vuetify/lib/components';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: appTheme,
        options: {
            customProperties: true
        },
          fonts:{
                body: {
                    family: fontes
                }
            }
    },
    lang: {
        current: i18n.locale,
        t: (key, ...params) => i18n.t(key, params),
    },
});

Vue.component('x-autocomplete', {
    extends: VAutocomplete,
    props: {
        'v-bind': "$props",
        underlined: {
            type: Boolean,
            default: true
        },
        'hide-details':{
            type: [Boolean, String],
            default:'auto'
        },
        'persistent-placeholder':{
            type: Boolean,
            default: true
        },
        'auto-select-first': {
            type: Boolean,
            default: true
        },
        'return-object': {
            type: Boolean,
            default: true,
        },
        /*clearable: {
            type: Boolean,
            default: true
        },
        'clear-icon': {
            type: String,
            default: 'mdi-close-circle-outline'
        }*/
    },
});

// Vue.component('x-text-field', {
//     extends: VTextField,
//     props: {
//         'v-bind': "$props",
//         underlined: {
//             type: Boolean,
//             default: true,
//         },
//         persistentPlaceholder: {
//             type: Boolean,
//             default:true,
//         },
//         hideDetails: {
//             type: [Boolean, String],
//             default: 'auto',
//         },
//     }
// });

// Vue.component('x-integer-field', {
//     extends: VTextField,
//     props: {
//         'v-bind': "$props",
//         type: {
//             type: String,
//             default: 'number'
//         },
//         underlined: {
//             type: Boolean,
//             default: true,
//         },
//         persistentPlaceholder: {
//             type: Boolean,
//             default: true,
//         },
//         hideSpinButtons: {
//             type: Boolean,
//             default: true,
//         },
//         hideDetails: {
//             type: [Boolean, String],
//             default: 'auto',
//         },
//     }
// });

// Vue.component('x-decimal-field', {
//     extends: VTextField,
//     props: {
//         'v-bind': "$props",
//         type: {
//             type: String,
//             default: 'number'
//         },
//         underlined: {
//             type: Boolean,
//             default: true,
//         },
//         persistentPlaceholder: {
//             type: Boolean,
//             default: true,
//         },
//         hideSpinButtons: {
//             type: Boolean,
//             default: true,
//         },
//         hideDetails: {
//             type: [Boolean, String],
//             default: 'auto',
//         },
//     }
// });

// Vue.component('x-currency-field', {
//     extends: VTextField,
//     props: {
//         'v-bind': "$props",
//         type: {
//             type: String,
//             default: 'number'
//         },
//         underlined: {
//             type: Boolean,
//             default: true,
//         },
//         persistentPlaceholder: {
//             type: Boolean,
//             default: true,
//         },
//         hideSpinButtons: {
//             type: Boolean,
//             default: true,
//         },
//         hideDetails: {
//             type: [Boolean, String],
//             default: 'auto',
//         },
//     }
// });

// Vue.component('x-date-field', {
//     extends: VTextField,
//     props: {
//         'v-bind': "$props",
//         type: {
//             type: String,
//             default: 'date'
//         },
//         underlined: {
//             type: Boolean,
//             default: true,
//         },
//         persistentPlaceholder: {
//             type: Boolean,
//             default: true,
//         },

//         hideDetails: {
//             type: [Boolean, String],
//             default: 'auto',
//         },
//     }
// });

Vue.component('x-checkbox', {
    extends: VCheckbox,
    props: {
        'v-bind': "$props",
        underlined:{
            type: Boolean,
            default: true,
        },
        hideDetails: {
            type: [Boolean, String],
            default: 'auto',
        },
        dense: {
            type: Boolean,
            default: true,
        },
    }
});

Vue.component('x-expansion-panels', {
    extends: VExpansionPanels,
    props: {
        'v-bind': "$props",
        focusable:{
            type: Boolean,
            default: false,
        },
        accordion: {
            type: Boolean,
            default: true,
        },  
    }
});
